import { render, staticRenderFns } from "./foot-page.vue?vue&type=template&id=7016840f&scoped=true&"
import script from "./foot-page.vue?vue&type=script&lang=js&"
export * from "./foot-page.vue?vue&type=script&lang=js&"
import style0 from "./foot-page.vue?vue&type=style&index=0&id=7016840f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7016840f",
  null
  
)

export default component.exports